/* tslint:disable */
/* eslint-disable */
/* Code generated by ng-openapi-gen DO NOT EDIT. */

import { HttpClient, HttpContext } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { Observable } from 'rxjs';
import { map } from 'rxjs/operators';

import { BaseService } from '../base-service';
import { ApiConfiguration } from '../api-configuration';
import { StrictHttpResponse } from '../strict-http-response';

import { PlatformApiResultOfAppDto } from '../models/platform-api-result-of-app-dto';
import { PlatformApiResultOfDataSourceResultDtoOfAppDto } from '../models/platform-api-result-of-data-source-result-dto-of-app-dto';
import { deleteAppsId } from '../fn/app/delete-apps-id';
import { DeleteAppsId$Params } from '../fn/app/delete-apps-id';
import { postApps } from '../fn/app/post-apps';
import { PostApps$Params } from '../fn/app/post-apps';
import { postAppsQueryDatasource } from '../fn/app/post-apps-query-datasource';
import { PostAppsQueryDatasource$Params } from '../fn/app/post-apps-query-datasource';
import { putApps } from '../fn/app/put-apps';
import { PutApps$Params } from '../fn/app/put-apps';

@Injectable({ providedIn: 'root' })
export class PlatformAppService extends BaseService {
  constructor(config: ApiConfiguration, http: HttpClient) {
    super(config, http);
  }

  /** Path part for operation `postAppsQueryDatasource()` */
  static readonly PostAppsQueryDatasourcePath = '/api/apps/query/datasource';

  /**
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `postAppsQueryDatasource()` instead.
   *
   * This method sends `application/json` and handles request body of type `application/json`.
   */
  postAppsQueryDatasource$Response(params: PostAppsQueryDatasource$Params, context?: HttpContext): Observable<StrictHttpResponse<PlatformApiResultOfDataSourceResultDtoOfAppDto>> {
    return postAppsQueryDatasource(this.http, this.rootUrl, params, context);
  }

  /**
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `postAppsQueryDatasource$Response()` instead.
   *
   * This method sends `application/json` and handles request body of type `application/json`.
   */
  postAppsQueryDatasource(params: PostAppsQueryDatasource$Params, context?: HttpContext): Observable<PlatformApiResultOfDataSourceResultDtoOfAppDto> {
    return this.postAppsQueryDatasource$Response(params, context).pipe(
      map((r: StrictHttpResponse<PlatformApiResultOfDataSourceResultDtoOfAppDto>): PlatformApiResultOfDataSourceResultDtoOfAppDto => r.body)
    );
  }

  /** Path part for operation `putApps()` */
  static readonly PutAppsPath = '/api/apps';

  /**
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `putApps()` instead.
   *
   * This method sends `application/json` and handles request body of type `application/json`.
   */
  putApps$Response(params: PutApps$Params, context?: HttpContext): Observable<StrictHttpResponse<PlatformApiResultOfAppDto>> {
    return putApps(this.http, this.rootUrl, params, context);
  }

  /**
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `putApps$Response()` instead.
   *
   * This method sends `application/json` and handles request body of type `application/json`.
   */
  putApps(params: PutApps$Params, context?: HttpContext): Observable<PlatformApiResultOfAppDto> {
    return this.putApps$Response(params, context).pipe(
      map((r: StrictHttpResponse<PlatformApiResultOfAppDto>): PlatformApiResultOfAppDto => r.body)
    );
  }

  /** Path part for operation `postApps()` */
  static readonly PostAppsPath = '/api/apps';

  /**
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `postApps()` instead.
   *
   * This method sends `application/json` and handles request body of type `application/json`.
   */
  postApps$Response(params: PostApps$Params, context?: HttpContext): Observable<StrictHttpResponse<PlatformApiResultOfAppDto>> {
    return postApps(this.http, this.rootUrl, params, context);
  }

  /**
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `postApps$Response()` instead.
   *
   * This method sends `application/json` and handles request body of type `application/json`.
   */
  postApps(params: PostApps$Params, context?: HttpContext): Observable<PlatformApiResultOfAppDto> {
    return this.postApps$Response(params, context).pipe(
      map((r: StrictHttpResponse<PlatformApiResultOfAppDto>): PlatformApiResultOfAppDto => r.body)
    );
  }

  /** Path part for operation `deleteAppsId()` */
  static readonly DeleteAppsIdPath = '/api/apps/{id}';

  /**
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `deleteAppsId()` instead.
   *
   * This method doesn't expect any request body.
   */
  deleteAppsId$Response(params: DeleteAppsId$Params, context?: HttpContext): Observable<StrictHttpResponse<PlatformApiResultOfAppDto>> {
    return deleteAppsId(this.http, this.rootUrl, params, context);
  }

  /**
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `deleteAppsId$Response()` instead.
   *
   * This method doesn't expect any request body.
   */
  deleteAppsId(params: DeleteAppsId$Params, context?: HttpContext): Observable<PlatformApiResultOfAppDto> {
    return this.deleteAppsId$Response(params, context).pipe(
      map((r: StrictHttpResponse<PlatformApiResultOfAppDto>): PlatformApiResultOfAppDto => r.body)
    );
  }

}
